import {
    createIconTextList,
    IconTextList,
} from '@vfde-brix/ws10/icon-text-list';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';

/**
 * Mounts an IconTextList by ID
 */
export const mountIconTextList = (containerId: string): IconTextList | null => {
    const containerElement = document.getElementById(containerId);

    /* istanbul ignore if */
    if (!containerElement) {
        return null;
    }

    const iconTextList = createIconTextList(containerElement, NO_PATTERN_BUSINESS_LOGIC);

    return iconTextList;
};
